import * as React from "react";
import styled from "styled-components";

import { select } from "@hubper/theme";

import Icon from "../../elements/Icon";

const Base = styled.div`
  padding: ${select.space(1)};
  cursor: pointer;
  transition: 0.2s;

  color: ${select.color(["grey", 2])};

  &:hover {
    color: ${select.color(["grey", 5])};
  }
`;

type Props = {
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
};

function CloseIcon({ style, className, onClick }: Props, ref: any) {
  return (
    <Base ref={ref} style={style} className={className} onClick={onClick}>
      <Icon size={32} name="close" />
    </Base>
  );
}

export default React.forwardRef(CloseIcon);
